import React from "react";
import styles from "./list_group_list.module.css";
import { getList } from "../../../listStore";
import Modal from "../../modal/modal";
import GroupListEditor from "../../listeditorelements/grouplisteditor/grouplisteditor";

const ListGroupList = (props) => {
    const type = getList("attributeTypes").group;
    const ViewElement = type.ViewElement || (() => null);
    const [modalVisible, setModalVisible] = React.useState(false);
    const [newValues, setNewValues] = React.useState({});

    const updateValue = (val, index) => {
        const pseudo = { ...(props.value || {}) };
        pseudo[index] = val;
        props.onChange(pseudo);
    };

    const removeValue = (index) => {
        const pseudo = Object.values({ ...(props.value || {}) });
        pseudo.splice(index, 1);
        props.onChange(pseudo);
    };

    const addValue = () => {
        setNewValues({});
        setModalVisible(true);
    };

    const clearModal = () => {
        setModalVisible(false);
    };

    const saveNewValues = () => {
        const pseudo = Object.values({ ...(props.value || {}) });
        pseudo.push({
            ...newValues,
        });
        props.onChange(pseudo);
        clearModal();
    };

    return (
        <div>
            <Modal
                isVisible={modalVisible}
                onClose={() => setModalVisible(false)}
            >
                <div className={styles.modalWrap}>
                    <GroupListEditor
                        {...props}
                        hubid={props.hubid}
                        item={{ ...newValues }}
                        setVal={(changes) => {
                            setNewValues({ ...newValues, ...changes });
                        }}
                    />
                    <div className={styles.modalButtons}>
                        <div
                            className={styles.modalButton}
                            style={{ color: "var(--danger-text-color)" }}
                            onClick={clearModal}
                        >
                            Cancel
                        </div>
                        <div
                            className={styles.modalButton}
                            style={{ color: "var(--link-text-color)" }}
                            onClick={saveNewValues}
                        >
                            Add To {props.attribute?.name}
                        </div>
                    </div>
                </div>
            </Modal>
            {Object.values(props.value || {}).map((value, index) => {
                return (
                    <div
                        key={`${props.attribute.ticketid}-${props.attribute.id}-${index}`}
                        style={{ marginBottom: "15px" }}
                    >
                        <ViewElement
                            {...props}
                            hubid={props.hubid}
                            value={value}
                            updateValue={(val) => {
                                updateValue(val, index);
                            }}
                            removeValue={() => removeValue(index)}
                        />
                    </div>
                );
            })}
            <button className="button is-link is-small" onClick={addValue}>
                <i
                    className="fas fa-plus"
                    style={{ fontSize: "12px", marginRight: "4px" }}
                ></i>{" "}
                Add To {props.attribute.name}
            </button>
        </div>
    );
};

export default ListGroupList;
